export default __webpack_public_path__ + "static/ritual_face_4-2835d91079561758633098b707114d1a.svg";